import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import { ChatBubbleInstaIcon, HeartIcon, SendIcon, MoreHorizIcon, CameraIcon, ArrowForwardIcon } from 'images'
import { useTranslation } from 'react-i18next'
import CarouselPreview from './elements/CarouselPreview'

const ReelsPreview = ({ data, isCarousel = false }) => {
  const bodyRef = useRef(null)
  const [isLongText, setIsLongText] = useState(false)
  const [showMore, setShowMore] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    if (bodyRef.current) {
      setIsLongText(bodyRef.current.scrollHeight > bodyRef.current.clientHeight)
    }
  }, [])

  const toggleShowMore = () => {
    setShowMore((prevState) => !prevState)
  }
  if (!data) return null

  const { page_name, profile_picture_url } = data ?? {}
  const isVideo = data.media?.url?.endsWith('.mp4') || data.media?.type === 'video'

  return (
    <div className={`reel ${isCarousel ? 'reels-carousel' : ''}`}>
      {!isCarousel && <div className="reel__background">
        {isVideo ? (
          <video className="reel__video" src={data.media.url} autoPlay loop muted playsInline />
        ) : (
          <div style={{ backgroundImage: `url(${data.media.url})` }} className="reel__background" />
        )}
      </div>}

      <div className={`reel__main-title ${isCarousel ? 'pb-0' : ''}`}>
        <h3>
          <strong>Reels</strong>
        </h3>
        <div>
          <CameraIcon width={25} />
        </div>
      </div>

      {isCarousel &&
        <CarouselPreview cards={data.carousel_cards} type="reels" callToAction={data.call_to_action} />
      }

      <div className="reel__info">
        <div className="d-flex p-3">
          <div className="d-flex flex-column gap-2 justify-content-end" style={{ width: '85%' }}>
            <div className="d-flex align-items-center w-100">
              <div>
                {profile_picture_url ? (
                  <img
                    alt={page_name}
                    className="reel__profile_picture"
                    src={profile_picture_url}
                    onError={(e) => {
                      e.target.style.display = 'none'
                      e.target.nextSibling.style.display = 'inline-block'
                    }}
                  />
                ) : null}
                <div className={`reel__icon ${data?.fb_info_loading ? 'loading' : ''}`} style={{ display: profile_picture_url ? 'none' : 'inline-block' }} />
              </div>
              {page_name ? (
                <p className="reel__title">
                  {page_name}
                  <span className="subtitle">Sponsored</span>
                </p>
              ) : data?.fb_info_loading ? (
                <div className="fb-error loading" />
              ) : (
                <div className="fb-error">{t('Recommendations.summary.fbPageInfoError')}</div>
              )}
            </div>

            {isCarousel && <div className="reel__link_order-now">
              <span>{data.call_to_action}</span>
              <span>
                <ArrowForwardIcon />
              </span>
            </div>}

            <p className="reel__caption">
              <span ref={bodyRef} className={`${showMore ? 'text' : 'text_clipped'}`}>
                {data.body}
              </span>
              {isLongText && (
                <span className="more" onClick={isCarousel ? undefined : toggleShowMore}>
                  {showMore ? 'less' : 'more'}
                </span>
              )}
            </p>

          </div>
          <div className={`reel__interactions ${isCarousel ? 'interactions-carousel' : ''}`} style={{ width: '15%' }}>
            <div className={`d-flex flex-column ${isCarousel ? 'gap-2' : 'gap-4'}`}>
              <span>
                <HeartIcon />
              </span>
              <span>
                <ChatBubbleInstaIcon />
              </span>
              <span>
                <SendIcon />
              </span>
              <span>
                <MoreHorizIcon />
              </span>
            </div>
          </div>
        </div>
        {!isCarousel && <div className="p-3 pt-0">
          <button className="reel__order-now">
            <div>{data.call_to_action}</div>
          </button>
        </div>}
      </div>
    </div>
  )
}

ReelsPreview.propTypes = {
  data: PropTypes.object,
}

export default ReelsPreview
